module.exports = "<div class=\"btn-group-vertical zoom-control\">\n  <button class=\"btn btn-default\"\n          [disabled]=\"!map || map.getZoom() >= map.getMaxZoom()\"\n          (click)=\"map?.zoomIn()\">\n    <i class=\"fa fa-plus\"></i>\n  </button>\n  <button class=\"btn btn-default\"\n          [disabled]=\"!map || map.getZoom() <= map.getMinZoom()\"\n          (click)=\"map?.zoomOut()\">\n    <i class=\"fa fa-minus\"></i>\n  </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/core/maps/controls/zoom.component.html
// module id = ../../../../../src/app/core/maps/controls/zoom.component.html
// module chunks = 0